export { }

declare global {
	interface Array<T> {
		remove(value: T): boolean;
	}
}

if (!Array.prototype.remove) {
	Object.defineProperty(Array.prototype, "remove", {
		value: function <T>(value: T) {
			const index = this.indexOf(value);
			if (index < 0)
				return false;
			this.splice(index, 1);
			return true;
		}
	});
}

